import { styled } from '@mui/material';
import Switch from '@mui/material/Switch';

const CustomSwitch: any = styled(Switch)(({ theme }) => ({
  width: 24,
  height: 24,
  padding: '5px 0',
  '&:not(.Mui-disabled):active': {
    '& .MuiSwitch-thumb': {
      width: 10,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(7.5px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: '8px 3px',

    '&:hover': {
      backgroundColor: 'transparent',
      '& + .MuiSwitch-track': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },

    '&.Mui-checked': {
      transform: 'translateX(9.5px)',
      '& .MuiSwitch-thumb': {
        backgroundColor: '#0052CC',
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        borderColor: '#0052CC',
        backgroundColor: 'transparent',
      },

      '&:hover': {
        backgroundColor: 'transparent',
        '& + .MuiSwitch-track': {
          backgroundColor: 'rgba(0, 82, 204, 0.04)',
        },
      },
    },

    '&.Mui-disabled': {
      '& .MuiSwitch-thumb': {
        opacity: 0.3,
      },
      '& + .MuiSwitch-track': {
        opacity: 0.3,
      },
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#6B778C',
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    borderRadius: 14 / 2,
    backgroundColor: 'transparent',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#6B778C',
    boxSizing: 'border-box',
  },
}));

export default CustomSwitch;